import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=76819642&scoped=true"
import script from "./MemberList.vue?vue&type=script&lang=js"
export * from "./MemberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76819642",
  null
  
)

export default component.exports